import React, { memo, useState, useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import CustomDialog from "../../../shared/components/CustomDialog";
import { DialogThemeFormOverflow } from "../../../shared/themes/dialogTheme";
import Form from "./subComponents/Form";
import ActionsButton from "./subComponents/ActionsButton";
import { defaultEnabledOptionsForm, defaultOptionsForm, defaultProtocolOptionsForm } from "../../../app/conf";

const FormGps = ({
    open = true,
    onClose,
    gps: { statuses, statusesFetching, submitFetching, gps_device, unlockFetching },
    company: { company },
    getCompanyRequest,
    submitGpsDevicesRequest,
    setCompany,
    unlockGpsRequest,
}) => {
    const { t } = useTranslation(["home", "devices", "users"]);

    const defaultOpt = useMemo(() => ({
        ...defaultOptionsForm,
        label: t(defaultOptionsForm.label)
    }), [t]);

    const [statusesOpt, setStatusesOpt] = useState([
        {
            ...defaultOptionsForm,
            label: t(defaultOptionsForm.label)
        }
    ]);
    const defaultEnabledOpt = useMemo(() =>
        defaultEnabledOptionsForm.map((opt) => ({
            ...opt,
            label: t(opt.label)
        })), [t]);

    const [name, setName] = useState("");
    const [observation, setObservation] = useState("");
    const [assigned, setAssigned] = useState(defaultOpt);
    const [enabled, setEnabled] = useState(defaultEnabledOpt[0]);
    const [status, setStatus] = useState(statusesOpt[0]);
    const [protocol, setProtocol] = useState(defaultProtocolOptionsForm[0]);
    const [simcard, setSimcard] = useState(statusesOpt[0]);
    const [device, setDevice] = useState(statusesOpt[0]);
    const [gpsDevicesCompany, setGpsDevicesCompany] = useState(null);

    const handleAssigned = user => setAssigned(user);
    const handleEnabled = enabled => setEnabled(defaultEnabledOpt.find(item => item.checked === enabled));
    const handleStatus = status => setStatus(status);
    const handleSimcard = simcard => setSimcard(simcard);
    const handleDevice = device => setDevice(device);
    const handleProtocol = protocol => setProtocol(protocol);
    const handleName = ev => setName(ev.target.value);
    const handleObservation = ev => setObservation(ev.target.value);

    useEffect(() => {

        if (Object.keys(gps_device).length) {
            setName(gps_device.name);
            setObservation(gps_device.observation);
            setProtocol({
                value: gps_device.protocol,
                label: gps_device.protocol
            });

            setStatus({
                value: gps_device.status._id,
                label: gps_device.status.name
            });
            if(typeof gps_device.device === 'object' && gps_device.device.hasOwnProperty("_id")){
                setDevice({
                    value: gps_device.device._id,
                    label: gps_device.device.imei
                });
            }
            if(typeof gps_device.simcard === 'object' && gps_device.simcard.hasOwnProperty("_id")){
                setSimcard({
                    value: gps_device.simcard._id,
                    label: gps_device.simcard.iccid
                });
            }

            if (gps_device.enabled) {
                setEnabled(defaultEnabledOpt[0]);
            } else {
                setEnabled(defaultEnabledOpt[1]);
            }

            if (Array.isArray(gps_device.assigned) && gps_device.assigned.length) {
                setAssigned({
                    value: gps_device.assigned[0]._id,
                    label: `${gps_device.assigned[0].name} ${gps_device.assigned[0].last_name} (${gps_device.assigned[0].username})`,
                    phone: gps_device.assigned[0].phone
                });

                // if (typeof gps_device.assigned[0].company === "string") {
                //     getCompanyRequest({ identifier: gps_device.assigned[0].company });
                // }

            }

            if (Array.isArray(gps_device.company) && gps_device.company.length) {
                setGpsDevicesCompany(gps_device.company[0].name);
            }

        }
    }, [gps_device, defaultEnabledOpt, getCompanyRequest]);

    // useEffect(() => {
    //     // TODO: Get company when device gps alredy exist and it has assigned user.
    //     if (Object.keys(company).length && gps_device.assigned.length) {
    //         setAssigned({
    //             value: gps_device.assigned[0]._id,
    //             label: `${gps_device.assigned[0].name} ${gps_device.assigned[0].last_name} (${gps_device.assigned[0].username})`,
    //             phone: gps_device.assigned[0].phone,
    //             company: company.name
    //         });s
    //     }

    // }, [company, gps_device])

    useEffect(() => {
        return () => {
            setCompany();
        }
    }, [setCompany])

    useEffect(() => {
        if (statuses.length) {
            setStatusesOpt([
                {
                    ...defaultOptionsForm,
                    label: t(defaultOptionsForm.label)
                },
                ...statuses.map(st => ({
                    label: st.name,
                    value: st._id
                }))
            ]);

            if (!gps_device.hasOwnProperty("_id")) {
                const statusAvailable = statuses.find(st => st.code.toLowerCase() === "en_prueba");
                setStatus({
                    value: statusAvailable._id,
                    label: statusAvailable.name
                });
            }
        }
    }, [statuses, gps_device, t]);

    return (
        <CustomDialog
            open={open}
            onClose={onClose}
            dialogTitle={t("home:gps")}
            dialogSubTitle={t("devices:gps_detail")}

            dialogRightTagSubtitle={gpsDevicesCompany ? t("users:company") : ""}
            dialogRightTag={gpsDevicesCompany ? gpsDevicesCompany : ""}
            dialogTheme={DialogThemeFormOverflow}
            dialogActions={
                <ActionsButton
                    submitFetching={submitFetching}
                    onClose={onClose}
                    submitGpsDevicesRequest={submitGpsDevicesRequest}
                    idGpsDevices={gps_device._id}
                    name={name}
                    observation={observation}
                    assigned={assigned}
                    enabled={enabled}
                    status={status}
                    protocol={protocol.value}
                    simcard={simcard}
                    device={device}
                    unlockFetching={unlockFetching}
                    unlockGpsRequest={unlockGpsRequest}
                    gps_device={gps_device}
                />
            }
        >
            <Form
                name={name}
                handleName={handleName}
                handleAssigned={handleAssigned}
                observation={observation}
                handleObservation={handleObservation}
                assigned={assigned}
                enabled={enabled}
                handleEnabled={handleEnabled}
                status={status}
                handleStatus={handleStatus}
                protocol={protocol}
                handleProtocol={handleProtocol}
                simcard={simcard}
                handleSimcard={handleSimcard}
                device={device}
                handleDevice={handleDevice}
                defaultEnabledOpt={defaultEnabledOpt}
                defaultUsersOpt={defaultOpt}
                statusesOpt={statusesOpt}
                statusesFetching={statusesFetching}
                idGpsDevices={gps_device._id}
                gpsDevice={gps_device}
                gpsDevicesCompany={gpsDevicesCompany}
                defaultProtocolOptions={defaultProtocolOptionsForm}
            />
        </CustomDialog>
    );
};

export default memo(FormGps);